/**
 * 달력 모바일 — 폰에서 칸을 탭하면 그 날짜 내용을 달력 아래에 펼친다
 *
 * 대상은 세 곳이다. 대시보드 6주 달력, 일정 모듈, 근태 모듈.
 *
 * 폰에서는 칸 안의 일정 줄이 점으로 눌려 있다(scss/cms/custom/schedule.scss).
 * 내용 자체는 DOM 에 그대로 남아 있어서 여기서는 그걸 아래 패널로 복사만 하면
 * 된다 — 서버를 다시 부르지 않는다.
 *
 * 세 달력이 지켜야 하는 약속:
 *   table.cal-mobile   달력 표
 *   .cal-date          날짜 (칸당 하나)
 *   .cal-item          일정 한 줄 (칸당 여러 개)
 *   .cal-detail        표 바로 뒤에 두는 빈 패널
 *
 * 데스크톱에서는 아무 일도 하지 않는다. 칸에 내용이 그대로 다 보이고 패널은
 * CSS 로 감춰져 있다.
 */
const MOBILE = '(max-width: 767.98px)';
const SELECTED = 'cal-selected';
const DOW = ['일', '월', '화', '수', '목', '금', '토'];

function isMobile() {
    return window.matchMedia(MOBILE).matches;
}

// 툴팁은 폰에서 띄울 방법이 마땅치 않다. 패널에는 어차피 전문이 보이니 떼어낸다.
function stripTooltip(el) {
    el.removeAttribute('data-bs-toggle');
    el.removeAttribute('data-bs-title');
    el.removeAttribute('data-bs-html');
    el.removeAttribute('title');
}

function textOf(el) {
    return el ? el.textContent.trim().replace(/\s+/g, ' ') : '';
}

function selectDay(table, td, panel) {
    table.querySelectorAll('td.' + SELECTED).forEach(function (el) {
        el.classList.remove(SELECTED);
    });
    td.classList.add(SELECTED);

    panel.innerHTML = '';

    // ── 제목: 월·일(요일) + 음력 + 공휴일·절기 이름 ────────────────────────
    // 칸의 열 위치가 곧 요일이다 (0=일)
    const dow = DOW[Array.prototype.indexOf.call(td.parentNode.children, td)] || '';
    const marks = textOf(td.querySelector('.day-marks'));

    // 달력에는 일(日)만 찍히지만 패널은 '지금 무슨 날을 보고 있는지' 를 혼자 말해야 하므로
    // 월을 함께 적는다. 값은 등록 링크의 ?date=YYYY-MM-DD 에서 가져온다 —
    // 표시된 숫자만 보고 월을 추측하면 앞뒤 달 칸(other-month)에서 어긋난다.
    const dateHref = td.querySelector('a.cal-date[href]');
    const ymd = dateHref ? (dateHref.getAttribute('href') || '').match(/(\d{4})-(\d{2})-(\d{2})/) : null;

    // 음력은 .cal-date 안에 같이 들어 있다. 합쳐서 읽으면 '27 7.5' 처럼 붙어 나오므로
    // 숫자만 따로 집고, 음력은 아래에서 별도 요소로 만든다(작고 흐리게).
    const dayText = textOf(td.querySelector('.day-number')) || textOf(td.querySelector('.cal-date'));
    const lunar = textOf(td.querySelector('.lunar'));

    let title = ymd
        ? Number(ymd[2]) + '월 ' + Number(ymd[3]) + '일'
        : dayText;
    if (dow) title += '(' + dow + ')';
    if (marks) title += ' ' + marks;

    const head = document.createElement('div');
    head.className = 'cal-detail-head';

    const dateEl = document.createElement('div');
    dateEl.className = 'cal-detail-date';
    dateEl.textContent = title;

    if (lunar) {
        const lunarEl = document.createElement('span');
        lunarEl.className = 'cal-detail-lunar';
        lunarEl.textContent = lunar;
        dateEl.appendChild(lunarEl);
    }

    head.appendChild(dateEl);

    // 날짜를 누르면 '이 날짜로 등록' 팝업이 뜨는 달력(일정·근태)이 있다. 폰에서는
    // 칸 전체가 탭 영역이라 그 링크를 막아 뒀으니(pointer-events:none) 여기로 옮긴다.
    const addLink = td.querySelector('a.cal-date[href]');
    if (addLink) {
        // 얕은 복사 — href 와 data-popup-* 만 가져오고 클래스는 새로 짠다.
        // 원래 클래스(.schedule-date)는 달력 칸용 레이아웃이라 버튼에는 안 맞는다.
        const btn = addLink.cloneNode(false);
        btn.className = 'popup btn btn-light btn-sm';
        btn.textContent = '등록';
        stripTooltip(btn);
        head.appendChild(btn);
    }

    panel.appendChild(head);

    // ── 본문: 그 날짜의 일정 줄을 그대로 복사 ──────────────────────────────
    const items = td.querySelectorAll('.cal-item');

    if (items.length === 0) {
        const none = document.createElement('div');
        none.className = 'text-muted fs-xs';
        none.textContent = '등록된 일정이 없습니다.';
        panel.appendChild(none);
        return;
    }

    items.forEach(function (item) {
        const clone = item.cloneNode(true);
        stripTooltip(clone);
        clone.querySelectorAll('[data-bs-toggle], [title]').forEach(stripTooltip);
        // 칸에서는 폭이 좁아 잘라냈지만 패널은 넉넉하다
        clone.classList.remove('text-truncate');
        clone.querySelectorAll('.text-truncate').forEach(function (el) {
            el.classList.remove('text-truncate');
        });
        panel.appendChild(clone);
    });
}

function initCalendar(table) {
    if (table.dataset.calInit) return;

    // 패널은 표를 감싼 .table-responsive 바로 뒤에 둔다
    const panel = (table.closest('.card') || document).querySelector('.cal-detail');
    if (!panel) return;

    table.dataset.calInit = '1';

    table.addEventListener('click', function (e) {
        if (!isMobile()) return;

        const td = e.target.closest('td');
        if (!td || !table.contains(td)) return;

        selectDay(table, td, panel);
    });

    // 처음에는 오늘을 펼쳐 둔다. 빈 패널이 덩그러니 있으면 탭해야 하는 걸 모른다.
    // 다른 달을 보고 있으면 오늘 칸이 없으므로 그때는 그냥 둔다.
    if (isMobile()) {
        const today = table.querySelector('td.today');
        if (today) selectDay(table, today, panel);
    }
}

function initAll() {
    document.querySelectorAll('table.cal-mobile').forEach(initCalendar);
}

// default.js 는 <head> 에서 읽히므로 이 시점에는 아직 표가 없다
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}
